"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _keyMirror = _interopRequireDefault(require("react-utils/keyMirror"));

/**
 * Used to categorize website grades.
 */
var _default = (0, _keyMirror.default)({
  BAD: null,
  OK: null,
  GOOD: null,
  GREAT: null
});

exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/constants/GradeTypeConstants.js
// module id = 26
// module chunks = 0